export default __webpack_public_path__ + "alberta-fab-icon.90905883c75a888febc6.svg";